import styled from 'styled-components';
import theme from '../../shared/mainThemeCss/index';

export const Title = styled.h1`
    color: ${(props) => theme.palette.text.titulo};
`;
